import initialState from '../../../store/initialState';
import * as liveAvailableShiftsTypes from '../services/LiveAvailableShiftsActionType';

const types = {...liveAvailableShiftsTypes};

const liveAvailableShiftsReducer = (state = initialState.liveAvailableShiftsReducer, action) => {
    switch (action.type) {
        case types.FETCH_LIVE_AVAILABLE_SHIFTS_REQUEST:
            return { ...state, isLiveAvailableShiftsLoading: true };
        case types.FETCH_LIVE_AVAILABLE_SHIFTS_SUCCESS:
            return { 
                ...state, 
                isLiveAvailableShiftsLoading: false, 
                liveAvailableShiftsData: action.payload?.values?.listAvailableShiftsRPCE || [],
                liveAvailableShiftsDataTotal: action.payload?.recordsTotal || 0,
            };
        case types.FETCH_LIVE_AVAILABLE_SHIFTS_FAILURE:
            return { 
                ...state, 
                isLiveAvailableShiftsLoading: false, 
                liveAvailableShiftsData: [],
                liveAvailableShiftsDataTotal: 0,
            };

        case types.FETCH_LEGEND_TABLE_DATA_REQUEST:
            return { ...state, isLegendLoading: true };
        case types.FETCH_LEGEND_TABLE_DATA_SUCCESS:
            return {
                ...state,
                isLegendLoading: false,
                LegendDDList: action.payload?.values?.Item2?.legendModel || [],
                ID: action.payload?.values?.Item1 || null,
                LastRefreshedInfo: action.payload?.values?.Item2?.CapacityVsDemandTableInfo.PublishedOn || '',
                datemodel: action.payload?.values?.Item2?.datemodel || []
            };
        case types.FETCH_LEGEND_TABLE_DATA_FAILURE:
            return {
                ...state,
                isLegendLoading: false,
                LegendDDList: [],
                ID: null,
                LastRefreshedInfo: '',
                datemodel: []
            };    


        // Common cases
        case types.UPDATE_LIVE_AVAILABLE_SHIFTS_REDUCER:
            return { ...state, ...action.payload };

        default:
            return state;
    }
}

export default liveAvailableShiftsReducer;